/* =========================================================================
   ISIM JEWELS — storefront behavior
   Cart drawer (AJAX / Section Rendering API), product gallery, variant &
   size selection, accordions, newsletter. Vanilla, no dependencies.
   ========================================================================= */
(function () {
  "use strict";

  var DRAWER_SECTION = "cart-drawer";
  var routes = (window.ISIM && window.ISIM.routes) || {};
  var addUrl    = (routes.cart_add    || "/cart/add")    + ".js";
  var changeUrl = (routes.cart_change || "/cart/change") + ".js";
  var cartUrl   = (routes.cart        || "/cart")        + ".js";

  /* ---------- helpers ------------------------------------------------ */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function postJSON(url, body) {
    return fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  /* ---------- cart drawer -------------------------------------------- */
  function drawerRoot() { return $("[data-cart-drawer]"); }

  function openBag() {
    var d = drawerRoot(); if (!d) return;
    d.setAttribute("data-open", "true");
    document.documentElement.style.overflow = "hidden";
    var close = $("[data-bag-close]", d);
    if (close) close.focus();
  }
  function closeBag() {
    var d = drawerRoot(); if (!d) return;
    d.removeAttribute("data-open");
    document.documentElement.style.overflow = "";
  }

  // Replace the drawer markup with freshly-rendered section HTML.
  function renderDrawer(html) {
    var current = drawerRoot();
    if (!current || !html) return;
    var doc = new DOMParser().parseFromString(html, "text/html");
    var fresh = doc.querySelector("[data-cart-drawer]");
    if (!fresh) return;
    var wasOpen = current.getAttribute("data-open") === "true";
    current.innerHTML = fresh.innerHTML;
    current.setAttribute("data-item-count", fresh.getAttribute("data-item-count") || "0");
    if (wasOpen) current.setAttribute("data-open", "true");
    syncCartCount(fresh.getAttribute("data-item-count"));
  }

  function syncCartCount(count) {
    var n = parseInt(count, 10) || 0;
    $all("[data-cart-count]").forEach(function (el) {
      el.textContent = n > 0 ? "(" + n + ")" : "";
    });
  }

  function addToCart(variantId, quantity) {
    return postJSON(addUrl, {
      items: [{ id: variantId, quantity: quantity || 1 }],
      sections: DRAWER_SECTION
    }).then(function (res) {
      if (res && res.sections && res.sections[DRAWER_SECTION]) {
        renderDrawer(res.sections[DRAWER_SECTION]);
      }
      openBag();
      return res;
    });
  }

  function changeLine(line, quantity) {
    return postJSON(changeUrl, {
      line: line, quantity: quantity, sections: DRAWER_SECTION
    }).then(function (cart) {
      if (cart && cart.sections && cart.sections[DRAWER_SECTION]) {
        renderDrawer(cart.sections[DRAWER_SECTION]);
      }
      if (cart && typeof cart.item_count !== "undefined") syncCartCount(cart.item_count);
      return cart;
    });
  }

  /* ---------- mobile menu drawer ------------------------------------- */
  function menuRoot() { return document.querySelector("[data-menu-drawer]"); }
  function openMenu() {
    var m = menuRoot(); if (!m) return;
    m.setAttribute("data-open", "true");
    document.documentElement.style.overflow = "hidden";
    var burger = document.querySelector("[data-menu-open]");
    if (burger) burger.setAttribute("aria-expanded", "true");
    var close = m.querySelector("[data-menu-close]");
    if (close) close.focus();
  }
  function closeMenu() {
    var m = menuRoot(); if (!m) return;
    m.removeAttribute("data-open");
    document.documentElement.style.overflow = "";
    var burger = document.querySelector("[data-menu-open]");
    if (burger) burger.setAttribute("aria-expanded", "false");
  }

  /* ---------- ring size guide drawer --------------------------------- */
  var sizeGuideTrigger = null;
  function sgDrawer() { return $("[data-sizeguide-drawer]"); }

  function openSizeGuide() {
    var d = sgDrawer(); if (!d) return;
    sizeGuideTrigger = document.activeElement;
    d.setAttribute("data-open", "true");
    d.setAttribute("aria-hidden", "false");
    document.documentElement.style.overflow = "hidden";
    var panel = $(".isim-sg__panel", d);
    if (panel) panel.focus();
    document.addEventListener("keydown", sizeGuideKeydown, true);
  }
  function closeSizeGuide() {
    var d = sgDrawer(); if (!d) return;
    d.removeAttribute("data-open");
    d.setAttribute("aria-hidden", "true");
    document.documentElement.style.overflow = "";
    document.removeEventListener("keydown", sizeGuideKeydown, true);
    if (sizeGuideTrigger && sizeGuideTrigger.focus) sizeGuideTrigger.focus();
    sizeGuideTrigger = null;
  }
  function sizeGuideKeydown(e) {
    if (e.key === "Escape") { e.preventDefault(); closeSizeGuide(); return; }
    if (e.key !== "Tab") return;
    var d = sgDrawer(); if (!d) return;
    var f = $all("button, [href], input, select, textarea, [tabindex]:not([tabindex='-1'])", d)
      .filter(function (el) { return el.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  /* ---------- delegated events --------------------------------------- */
  document.addEventListener("click", function (e) {
    var t = e.target.closest("[data-bag-open], [data-bag-close], [data-bag-scrim], [data-menu-open], [data-menu-close], [data-sizeguide-open], [data-sizeguide-close], [data-line-change], [data-line-remove], [data-accordion-trigger], [data-thumb]");
    if (!t) return;

    if (t.hasAttribute("data-bag-open"))  { e.preventDefault(); openBag(); return; }
    if (t.hasAttribute("data-bag-close") || t.hasAttribute("data-bag-scrim")) { e.preventDefault(); closeBag(); return; }
    if (t.hasAttribute("data-menu-open"))  { e.preventDefault(); openMenu(); return; }
    if (t.hasAttribute("data-menu-close")) { e.preventDefault(); closeMenu(); return; }
    if (t.hasAttribute("data-sizeguide-open"))  { e.preventDefault(); openSizeGuide(); return; }
    if (t.hasAttribute("data-sizeguide-close")) { e.preventDefault(); closeSizeGuide(); return; }

    if (t.hasAttribute("data-line-change")) {
      e.preventDefault();
      var line = parseInt(t.getAttribute("data-line"), 10);
      var qty  = parseInt(t.getAttribute("data-line-change"), 10);
      changeLine(line, qty);
      return;
    }
    if (t.hasAttribute("data-line-remove")) {
      e.preventDefault();
      changeLine(parseInt(t.getAttribute("data-line"), 10), 0);
      return;
    }
    if (t.hasAttribute("data-accordion-trigger")) {
      toggleAccordion(t);
      return;
    }
    if (t.hasAttribute("data-thumb")) {
      swapGallery(t);
      return;
    }
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") { closeBag(); closeMenu(); }
  });

  /* ---------- accordions --------------------------------------------- */
  function toggleAccordion(btn) {
    var panel = btn.nextElementSibling;
    var open = btn.getAttribute("aria-expanded") === "true";
    btn.setAttribute("aria-expanded", open ? "false" : "true");
    var sign = $("[data-acc-sign]", btn);
    if (sign) sign.textContent = open ? "+" : "−";
    if (panel) panel.style.maxHeight = open ? "0px" : (panel.scrollHeight + 40) + "px";
  }

  /* ---------- product gallery ---------------------------------------- */
  function swapGallery(thumb) {
    var main = $("[data-gallery-main]");
    var src = thumb.getAttribute("data-thumb");
    if (main && src) main.src = src;
    $all("[data-thumb]").forEach(function (el) {
      el.setAttribute("data-active", el === thumb ? "true" : "false");
    });
  }

  /* ---------- product form: variants, size, add ---------------------- */
  function initProductForm(form) {
    var variants;
    try { variants = JSON.parse($("[data-variants-json]", form).textContent); }
    catch (err) { variants = []; }

    var hasOptions = $all("[data-option-index]", form).length > 0;
    var addBtn = $("[data-add-btn]", form);
    var labels = {
      add:    addBtn.getAttribute("data-label-add"),
      preorder: addBtn.getAttribute("data-label-preorder"),
      select: addBtn.getAttribute("data-label-select"),
      added:  addBtn.getAttribute("data-label-added"),
      soldout: addBtn.getAttribute("data-label-soldout")
    };

    var selected = {}; // optionIndex -> value

    function currentVariant() {
      if (!hasOptions) return variants[0];
      var chosen = $all("[data-option-index]", form).map(function (g) {
        return selected[g.getAttribute("data-option-index")];
      });
      if (chosen.indexOf(undefined) !== -1) return null;
      return variants.filter(function (v) {
        return v.options.every(function (opt, i) { return opt === chosen[i]; });
      })[0] || null;
    }

    function refresh() {
      var v = currentVariant();
      var idField = $("[data-variant-id]", form);
      var note = $("[data-preorder-note]", form);
      var prop = $("[data-preorder-prop]", form);
      function setNote(on) {
        if (note) note.style.display = on ? "block" : "none";
        if (prop) prop.disabled = !on;
      }
      if (hasOptions && !v) {
        addBtn.textContent = labels.select;
        addBtn.disabled = true;
        setNote(false);
        return;
      }
      if (v && v.available === false) {
        addBtn.textContent = labels.soldout;
        addBtn.disabled = true;
        setNote(false);
        if (idField) idField.value = v.id;
        return;
      }
      if (v && v.preorder) {
        addBtn.textContent = labels.preorder;
        addBtn.disabled = false;
        setNote(true);
        if (idField) idField.value = v.id;
        return;
      }
      addBtn.textContent = labels.add;
      addBtn.disabled = false;
      setNote(false);
      if (v && idField) idField.value = v.id;
    }

    // option pill selection
    $all("[data-option-value]", form).forEach(function (pill) {
      pill.addEventListener("click", function () {
        var group = pill.closest("[data-option-index]");
        var idx = group.getAttribute("data-option-index");
        selected[idx] = pill.getAttribute("data-option-value");
        $all("[data-option-value]", group).forEach(function (p) {
          p.setAttribute("data-active", p === pill ? "true" : "false");
        });
        refresh();
      });
    });

    // preselect when single-variant / single value groups
    if (!hasOptions && variants[0]) {
      var idField = $("[data-variant-id]", form);
      if (idField) idField.value = variants[0].id;
    }
    refresh();

    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var v = currentVariant();
      if (!v) { refresh(); return; }
      var idField = $("[data-variant-id]", form);
      var id = idField ? idField.value : v.id;
      addToCart(id, 1).then(function () {
        addBtn.textContent = labels.added;
        setTimeout(refresh, 1600);
      });
    });
  }

  /* ---------- product recommendations (API swap) --------------------- */
  function initRecommendations() {
    $all("[data-product-recommendations]").forEach(function (el) {
      var url = el.getAttribute("data-recommendations-url");
      if (!url) return;
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, "text/html");
          var fresh = doc.querySelector("[data-product-recommendations]");
          if (fresh) el.innerHTML = fresh.innerHTML;
        })
        .catch(function () { /* keep the server-rendered fallback */ });
    });
  }

  /* ---------- newsletter (graceful, native form still posts) --------- */
  function initNewsletter() {
    // Shopify customer form posts normally; success handled by ?customer_posted=true
    var params = new URLSearchParams(window.location.search);
    if (params.get("customer_posted") === "true") {
      $all("[data-newsletter-success]").forEach(function (el) { el.hidden = false; });
      $all("[data-newsletter-form]").forEach(function (el) { el.hidden = true; });
    }
  }

  /* ---------- init --------------------------------------------------- */
  function init() {
    $all("[data-product-form]").forEach(initProductForm);
    initRecommendations();
    initNewsletter();
    // set initial accordion panels closed height
    $all("[data-accordion-trigger][aria-expanded='true']").forEach(function (b) {
      var panel = b.nextElementSibling;
      if (panel) panel.style.maxHeight = (panel.scrollHeight + 40) + "px";
    });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();

  // expose for inline handlers / debugging
  window.ISIM = window.ISIM || {};
  window.ISIM.openBag = openBag;
  window.ISIM.closeBag = closeBag;
  window.ISIM.addToCart = addToCart;
})();
